module.exports = __webpack_public_path__ + "static/img/xc2.269491c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xc2.jpg
// module id = 6Kmy
// module chunks = 0